import { useMobile } from "@/hooks";
import React, { useEffect, useState } from "react";

import { getProfileData } from "../../api/networkUtils";
import { PersonalDetailsResponse } from "../../types/setting";
import BlockCompany from "./block-company";
import ContactVisibility from "./contact-visibility";
import ProfileAutoUpdate from "./profile-auto-update";
import ProfileVisibility from "./profile-visibility";

const Profile = () => {
  const isMobile = useMobile();
  const [personalDetails, setPersonalDetails] =
    useState<PersonalDetailsResponse | null>(null);
  useEffect(() => {
    const fetchProfileData = async () => {
      const profileField = "personal_details";
      const response = await getProfileData(profileField);
      setPersonalDetails(response);
    };
    fetchProfileData();
  }, []);

  return (
    <div className="my-1 flex flex-col gap-4">
      <div className="text-xs font-normal leading-3 text-[#777585]">
        Applies to all your profiles
      </div>
      <ProfileAutoUpdate isMobile={isMobile} />
      <BlockCompany isMobile={isMobile} />
      <ProfileVisibility
        isMobile={isMobile}
        personalDetails={personalDetails}
      />
    </div>
  );
};

export default Profile;
